import { render, staticRenderFns } from "./PerduView.vue?vue&type=template&id=038bd1a2&scoped=true"
var script = {}
import style0 from "./PerduView.vue?vue&type=style&index=0&id=038bd1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038bd1a2",
  null
  
)

export default component.exports